import script from "./EditProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./EditProfile.vue?vue&type=script&setup=true&lang=js"

import "./EditProfile.vue?vue&type=style&index=0&id=63400b1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63400b1c"]])

export default __exports__